var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('NavBar'),_c('div',{staticClass:"flex-center"},[_c('NotificationSettings',{staticClass:"card",attrs:{"userId":_vm.$route.query.tok}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }